<div *ngIf="displayActionBtn; else cardWithoutAction" class="saldo-card-action">
  <div class="p-d-flex p-jc-between p-ai-center">
    <div>
      <div class="text before">
        {{ topText }}
        <kodit-helper-icon
          [helperText]="helperIcon"
          *ngIf="helperIcon"
        ></kodit-helper-icon>
      </div>
      <div [ngClass]="'text main ' + mainTextClass">{{ mainText }}</div>
      <div class="text after" *ngIf="bottomText">{{ bottomText }}</div>
      <ng-content select="[additional-content]"> </ng-content>
      <div *ngIf="mainText2">
        <div class="text before">{{ topText2 }}</div>
        <div class="text main">{{ mainText2 }}</div>
        <div class="text after" *ngIf="bottomText2">{{ bottomText2 }}</div>
      </div>
      <div *ngIf="mainText3">
        <div class="text before">{{ topText3 }}</div>
        <div class="text main">{{ mainText3 }}</div>
        <div class="text after" *ngIf="bottomText3">{{ bottomText3 }}</div>
      </div>
    </div>
    <div>
      <ng-content select="[action-button]"> </ng-content>
    </div>
  </div>
</div>

<ng-template #cardWithoutAction>
  <div class="saldo-card">
    <div>
      <div class="text before">
        {{ topText }}
        <kodit-helper-icon
          [helperText]="helperIcon"
          *ngIf="helperIcon"
        ></kodit-helper-icon>
      </div>
      <div [ngClass]="'text main ' + mainTextClass">{{ mainText }}</div>
      <div class="text after" *ngIf="bottomText">{{ bottomText }}</div>
      <ng-content select="[additional-content]"> </ng-content>
    </div>
    <div *ngIf="mainText2">
      <div class="text before">{{ topText2 }}</div>
      <div class="text main">{{ mainText2 }}</div>
      <div class="text after" *ngIf="bottomText2">{{ bottomText2 }}</div>
    </div>
    <div *ngIf="mainText3">
      <div class="text before">{{ topText3 }}</div>
      <div class="text main">{{ mainText3 }}</div>
      <div class="text after" *ngIf="bottomText3">{{ bottomText3 }}</div>
    </div>
  </div>
</ng-template>
